var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.suggestions.length && _vm.fieldFocus)?_c('div',{attrs:{"id":"search-suggestions"}},[_c('ul',_vm._l((_vm.suggestions),function(suggestion,index){return _c('li',{key:suggestion.brandName +
          suggestion.temper +
          suggestion.isoDesignation +
          index,on:{"click":function($event){return _vm.searchByKeyword(suggestion)}}},[_vm._v("\n      "+_vm._s(suggestion.brandName)+"\n    ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }